import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import React, { useState } from 'react';
import util from '../util';
import strings from '../Globalization';
import Model from '../models/model';
import consts from '../consts';
import connectionService from '../services/Connection';
import { useModelForm } from '../contexts/ModelForm';
import PreviewTopics from '../components/common/PreviewTopics';

const fieldsToCheck = [
	'CmdPermission',
	'DataPermission',
	'SubCmdPermission',
	'SubDataPermission',
	'SubTDataPermission',
	'Subscription',
	'TDataPermission',
	'Publish',
	'PublishDeviceType'
];
const {subComparisonObj, SubPermissionObj, SubPermissionObjTopic, publishComparisonObj, PubPermissionObj, PubPermissionObjTopic, linkToTrackingSystemValidation} = consts

const { onChangeSerialNumber, onChangeTopic } = util
export const Bull = styled(Box, {
	shouldForwardProp: (prop) => prop !== 'value'
})(({ theme, value }) => ({
	width: theme.spacing(2),
	height: theme.spacing(2),
	borderRadius: theme.spacing(2),
	backgroundColor: value ? theme.palette.success.main : theme.palette.error.main,
}));
const autocompleteValueFormatter = (value) => {
	let formatedValue = [];
	if (Array.isArray(value)) {
		formatedValue = value?.map((entry) => entry?.id || entry);
	}
	return formatedValue;
}

const onCreateOption = (LookupTypeId) => (value) => {
	let action = 'save'
	let id = 0
	const formData = new FormData();
	formData.append('action', action);
	formData.append('id', id);
	formData.append('LookupTypeId', LookupTypeId);
	formData.append('CustomStringValue', value.option.id);
	formData.append('DisplayValue', value.option.id);
	try {
		fetch(connectionService.TopicPermissionLookup, {
			method: 'POST',
			body: formData,
			credentials: 'include'
		})
	} catch (error) {
		console.error('Error creating record:', error);
	}
}

const isLimitedUser = () => {
	const roles = util.localData?.loginData?.roles;
	const isLimited = Array.isArray(roles)
		? roles.includes('Administrator') || roles.includes('Viewer')
		: roles === 'Administrator' || roles === 'Viewer';
	return isLimited;

}

const deviceTypes = ['Tracking System', 'CAT Export Tracker', "External Tracking System", "RFID Middleware"]

const CommandButton = ({ row }) => {
	const { id, SerialNumber, EquipmentType } = row
	return (
		<Button
			color="success"
			variant="contained"
			title={strings.Command}
			size="small"
			to={`/command?clientCommandId=${id}&returnTo=/authorizedclients`}
			component={Link}
			disabled={deviceTypes.includes(EquipmentType) || util?.getLoginData()?.roles[0] === "Viewer" }
		>
			{strings.Command}
		</Button> 
	);
}

const roleCheck = () => {
	if (consts.RoleCheck.includes(util?.getLoginData()?.roles[0])) {
		return true
	}
	else {
		return false
	}
}
const customizeInput = ({ Input, inputProps }) => {
	const field = inputProps.field
	if (inputProps.formik.values[field].length === 1 && inputProps.formik.values[field][0] === '')
		inputProps.formik.values[field] = []
	return (
		<Input {...inputProps} />
	)
}
const getDevicePermissions = ({ DeviceTypePermission, EquipmentType = '' }) => {
	if (DeviceTypePermission) {
		return DeviceTypePermission?.map(obj => {
			const subscriptionTopic = [];
			const publishTopic = [];
			obj.Publish.length && publishTopic.push('+/data');
			obj.PublishTData.length && publishTopic.push('+/tdata');
			obj.PublishData.length && publishTopic.push('+/data');
			obj.PublishCmdData.length && publishTopic.push('+/cmd');
			obj.Subscription.length && subscriptionTopic.push('+/data');
			obj.SubscribeData.length && subscriptionTopic.push('+/data');
			obj.SubscribeTData.length && subscriptionTopic.push('+/tdata');
			obj.SubscribeCmdData.length && subscriptionTopic.push('+/cmd');
			if (EquipmentType?.toLowerCase() === 'ct') {
				publishTopic.push('data/#');
			}
			return {
				[obj.EquipmentType]: {
					Subscription: obj.Subscription,
					Publish: obj.Publish,
					DataPermission: obj.PublishData,
					TDataPermission: obj.PublishTData,
					CmdPermission: obj.PublishCmdData,
					SubDataPermission: obj.SubscribeData,
					SubTDataPermission: obj.SubscribeTData,
					SubCmdPermission: obj.SubscribeCmdData,
					PublishDeviceType: obj.PublishDeviceType
				}
			};
		});
	}
}
const populateTopic = ({ formik, activeRecord = {}, value }) => {
	const { record } = activeRecord;
	const { DeviceTypePermission = [] } = activeRecord?.combos ||{};
	const devicePermission = getDevicePermissions({ DeviceTypePermission, EquipmentType: value });
	let permissions = devicePermission.find(
		obj => Object.keys(obj)[0] === value
	);
	if (permissions) {
		permissions = Object.values(permissions)[0];

		let _loop = function _loop(permission) { // Should be arrow function, _loop function name is unnecessary
			if (permissions[permission]) {
				permissions[permission]?.map(function (obj) {
					return (
						(!record[permission] ||
							(!permissions[permission].includes(obj) && !record[permission].includes(obj))) &&
						permissions[permission].push(obj)
					);
				});
				record[permission] = permissions[permission];
			}
		};

		for (const permission in permissions) {
			_loop(permission);
		}
	}
	record['SerialNumber'] = '';
	record['EquipmentType'] = value;
	if (record.TDataPermission[0] === '' && record.PublishDeviceType[0] === '' && record.DataPermission[0] === '' && record.CmdPermission[0] === '') {
		record.Publish = [];
	}
	if (record.SubTDataPermission[0] === '' && record.SubDataPermission[0] === '' && record.SubCmdPermission[0] === '') {
		record.Subscription = [];
	}
	if (value === "C") {
		let findItext = record.Subscription.findIndex(function (item) {
			return item === '+/tdata';
		});
		findItext = findItext > -1 ? record.Subscription.splice(findItext, 1) : record.Subscription;
		let findIndex = record.Publish.findIndex(function (item) {
			return item === '+/tdata';
		});
		findIndex = findIndex > -1 ? record.Publish.splice(findIndex, 1) : record.Publish;
	}
	let SubscriptionTopic = record.Subscription;

	formik?.setFieldValue?.('Subscription', SubscriptionTopic);
	formik?.setFieldValue?.('SubTDataPermission', record.SubTDataPermission);
	formik?.setFieldValue?.('SubDataPermission', record.SubDataPermission);
	formik?.setFieldValue?.('SubCmdPermission', record.SubCmdPermission);

	//Publish 
	formik?.setFieldValue?.('Publish', record.Publish);
	formik?.setFieldValue?.('TDataPermission', record.TDataPermission);
	formik?.setFieldValue?.('PublishDeviceType', record.PublishDeviceType);
	formik?.setFieldValue?.('DataPermission', record.DataPermission);
	formik?.setFieldValue?.('CmdPermission', record.CmdPermission);
	formik?.setFieldValue?.('SerialNumber', '');
}

const PreviewBrokerTopics = () => {
	const [open, setOpen] = useState(false)
	const { formik, activeRecord } = useModelForm()
	const data = formik.values;

	return (
		<PreviewTopics activeRecord={activeRecord} data={data} open={open} setOpen={setOpen} />
	)

}
/**
 * Updates form values based on changes in the Subscription field and related dependencies.
 *
 * @param {object} props - An object containing the following properties:
 *   - `formik` (Formik instance): The Formik instance managing the form state.
 *   - `value` (any): The new value for the "Subscription" field.
 *   - `isFromTopicPermission` (boolean, optional): Indicates if the change originates from topic permission selection. Defaults to `false`.
 *
 * @returns {void}
 *
 * @example
 * onChangeSubscription({ formik: myFormik, value: 'newSubscriptionValue' });
 */
export const onChangeSubscription =  ({ formik, value, isFromTopicPermission, reload }) => {
	let values = { ...formik.values, Subscription: value };
	let depsUpdateRequired = false;
	for (const item of subComparisonObj) {
		const { updatedValues, isUpdate } = updateValues({ value, objName: item.key, objValue: item.value, depsUpdateRequired, values, eventKey: 'Subscription', blankKeys: item.blankKeys });
		values = updatedValues;
		depsUpdateRequired = isUpdate;
	}
	for (const topic of value) {
		if(topic.includes('#')) {
			const topicName = topic.split('/')[0];
			// clearing the feild for tdata, data, cmd
			const topicObject = isFromTopicPermission? SubPermissionObjTopic : SubPermissionObj;
			const subTopic = topicObject[topicName];
			if(subTopic) {
				//clear the field values
				values = {...values, [subTopic]: []}
				depsUpdateRequired = true;
			}
		}
	}
	if (depsUpdateRequired) {
		formik.setValues(values);
	}
	if (!reload) {
		shouldPromptAndUnauthorize({ formik, isNotCall: true });
	}
}
/**
 * Updates form values based on changes in the Publish field and related dependencies.
 *
 * @param {object} props - An object containing the following properties:
 *   - `formik` (Formik instance): The Formik instance managing the form state.
 *   - `value` (any): The new value for the "Publish" field.
 *   - `isFromTopicPermission` (boolean, optional): Indicates if the change originates from topic permission selection. Defaults to `false`.
 *
 * @returns {void}
 *
 * @example
 * onChangePublish({ formik: myFormik, value: 'newPublishValue' });
 */
export const onChangePublish = ({ formik, value, isFromTopicPermission, activeRecord, reload }) => {
	let values = { ...formik.values, Publish: value };
	let depsUpdateRequired = false;
	for (const item of publishComparisonObj) {
		const { updatedValues, isUpdate } = updateValues({ value, objName: item.key, objValue: item.value, depsUpdateRequired, values, eventKey: 'Publish', blankKeys: item.blankKeys });
		values = updatedValues;
		depsUpdateRequired = isUpdate;
	}
	for (const topic of value) {
		if(topic.includes('#')) {
			const topicName = topic.split('/')[0];
			// clearing the feild for tdata, data, cmd
			const topicObject = isFromTopicPermission? PubPermissionObjTopic : PubPermissionObj;
			const pubTopic = topicObject[topicName];
			if(pubTopic) {
				// clear multiple field values
				if(Array.isArray((pubTopic))) {
					const newValues = pubTopic.map(field => ({[field] : []}));
					//clear the field values
					values = Object.assign(values, ...newValues)
				}else {
					//clear the field values
					values = {...values, [pubTopic]: []}
				}
				depsUpdateRequired = true;
			}
		}
	}
	if (depsUpdateRequired) {
		formik.setValues(values);
	}
	if (!reload) {
		shouldPromptAndUnauthorize({ formik, isNotCall: true, activeRecord });
	}
}
/**
 * Customizes the data to be saved by performing necessary modifications based on certain conditions.
 *
 * @param {object} toSave - The data object to be saved.
 * @returns {object} The modified data object.
 */
export const customizeSave = (toSave) => {
	// Check if the EquipmentType is included in the linkToTrackingSystemValidation array
	if (linkToTrackingSystemValidation.includes(toSave?.EquipmentType)) {
		delete toSave.LinkToTrackingSystems;
		toSave.LinkToRFIDSystems = toSave?.LinkToRFIDSystems ? toSave?.LinkToRFIDSystems : 0;
	} else {
		delete toSave.LinkToRFIDSystems;
		toSave.LinkToTrackingSystems = toSave?.LinkToTrackingSystems ? toSave?.LinkToTrackingSystems : 0;
	}
	// Add '+/data' to the Publish array if DataPermission has values
	if (toSave.DataPermission.length && !toSave.Publish.includes('+/data')) {
		toSave.Publish.push('+/data')
	}
	// Add '+/cmd' to the Publish array if CmdPermission has values
	if (toSave.CmdPermission.length && !toSave.Publish.includes('+/cmd')) {
		toSave.Publish.push('+/cmd')
	}
	// Add '+/tdata' to the Publish array if TDataPermission has values
	if (toSave.TDataPermission.length && !toSave.Publish.includes('+/tdata')) {
		toSave.Publish.push('+/tdata')
	}
	// Add '+/data' to the Subscription array if SubDataPermission has values
	if (toSave.SubDataPermission.length && !toSave.Subscription.includes('+/data')) {
		toSave.Subscription.push('+/data')
	}
	// Add '+/cmd' to the Subscription array if SubCmdPermission has values
	if (toSave.SubCmdPermission.length && !toSave.Subscription.includes('+/cmd')) {
		toSave.Subscription.push('+/cmd')
	}
	// Add '+/tdata' to the Subscription array if SubTDataPermission has values
	if (toSave.SubTDataPermission.length && !toSave.Subscription.includes('+/tdata')) {
		toSave.Subscription.push('+/tdata')
	}

	return toSave;
}

const updateValues =  ({ value, objName, objValue, depsUpdateRequired, values, eventKey, blankKeys }) => {
	if (Array.isArray(value) && value.includes(objName) && value.indexOf(objValue) >= value.indexOf(objName)) {
		const publish = JSON.parse(JSON.stringify(value))
		publish.splice(publish.indexOf(objName), 1);
		depsUpdateRequired = true;
		values[eventKey] = publish;
		for (const key of blankKeys) {
			values[key] = [];
		}
	}
	return { updatedValues: values, isUpdate: depsUpdateRequired }
};

const shouldPromptAndUnauthorize = async ({ formik, value, key, topic, isNotCall = false }) => {
	if (formik.values.IsAuthorize) {
		util.showError(
			strings.ReAuthorizePrompt,
			strings.Info,
			'info'
		);
		formik.setFieldValue('IsAuthorize', false);
	}
	if (!isNotCall) {
		onChangeTopic({ formik, value, key, topic })
	}
}

const checkArrayEquality = (arr1, arr2) => {
	const set1 = new Set(arr1);
	const set2 = new Set(arr2);
	return set1.size === set2.size && [...set1].every(value => set2.has(value));
}

const disableAuthorize = ({ formik, activeRecord }) => {
	return !fieldsToCheck.every(field =>
		checkArrayEquality(formik.values[field], activeRecord.record[field])
	);
};
const model = new Model({
	name: 'AuthorizedClients', //Requests',
	gridTitle: 'AuthorizedClients',
	api: 'AuthorizedClients',
	idProperty: '_id',
	disableAdd: true,
	disableDelete: true,
	readOnly: isLimitedUser,
	formTitleField: 'ClientName',
	module: 'AuthorizedClients',
	showGridRefreshBtn: true,
	defaultSort: 'LastConnection DESC',
	filter: [{ operator: '$eq', value: true, property: 'IsAuthorize', type: 'boolean' }],
	onFormLoad: ({ formik }) => {
		onChangeSubscription({ formik, value: formik.values.Subscription, reload: true });
		onChangePublish({ formik, value: formik.values.Publish, reload: true });
	},
	customizeSaveData: customizeSave,
	onRecordSaved: (res, { data, searchParams, setSearchParams }) => {
		if(!data.IsAuthorize) {
			searchParams.set('returnTo', encodeURIComponent('/clientrequests'));
			setSearchParams(searchParams);
		}
	},
	comboTypes: [
		{ type: 'Hospital', loaded: true },
		{ type: 'DeviceType', loaded: true },
		{ type: 'LinkToTrackingSystems', loaded: true },
		{ type: 'PubTopics', loaded: true },
		{ type: 'SubTopics', loaded: true },
		{ type: 'DataTopics', loaded: true },
		{ type: 'TDataTopics', loaded: true },
		{ type: 'CMDDataTopics', loaded: true },
		{ type: 'DeviceTypePermission', loaded: true },
		{ type: 'LinkToRFIDSystems', loaded: true },
		{ type: 'AuthorizationMode', loaded: true }
	],
	formGroups: [
		{
			fields: [
				'ClientName',
				'HospitalName',
				'EquipmentType',
				'LinkToRFIDSystems',
				'LinkToTrackingSystems',
				'MachineName',
				'SerialNumber',
				'MacAddress',
				'DeviceFamily',
				'DeviceModel'
			],
			columnSize: 12
		},
		{
			header: 'Subscribe',
			fields: ['Subscription', 'SubDataPermission', 'SubTDataPermission', 'SubCmdPermission'],
			columnSize: 6,
			headerProps: {
				sx: {
					padding: (theme) => theme.spacing(0.5),
					backgroundColor: 'primary.main',
					textAlign: 'center',
					width: '100%',
					color: 'background.paper',
					borderRadius: (theme) => theme.spacing(0.5)
				}
			},
			fieldProps: {
				inlineLabel: true
			}
		},
		{
			header: 'Publish',
			fields: ['Publish', 'DataPermission', 'TDataPermission', 'CmdPermission', 'PublishDeviceType'],
			columnSize: 6,
			headerProps: {
				sx: {
					padding: (theme) => theme.spacing(0.5),
					backgroundColor: 'primary.main',
					textAlign: 'center',
					width: '100%',
					color: 'background.paper',
					borderRadius: (theme) => theme.spacing(0.5)
				}
			},
			fieldProps: {
				inlineLabel: true
			}
		},
		{
			fields: ['IsAuthorize', 'AllowUnauthorizedTopics', 'AuthorizationMode'],
			columnSize: 12
		}
	],
	formActions: [
		{ Component: PreviewBrokerTopics },
	],
	columns: [
		{ header: 'UniqueId', field: 'ClientRequestsId', width: 250, hidden: true },
		{ field: 'ClientName', header: 'ClientName', width: 250, pdfExportWidth: 50, required: true },
		{ field: 'HospitalName', header: 'HospitalName1', width: 150, pdfExportWidth: 50, lookup: 'Hospital', required: true },
		{
			field: 'EquipmentType',
			header: 'DeviceType',
			width: 180,
			pdfExportWidth: 60,
			lookup: 'DeviceType',
			required: true,
			onChange: populateTopic
		},
		{
			field: 'LinkToTrackingSystems',
			header: 'LinkToTrackingSystems',
			width: 200,
			pdfExportWidth: 60,
			lookup: 'LinkToTrackingSystems',
			inputWhen: [{ field: 'EquipmentType', op: 'nin', value: ['CT', 'ETS', 'T'] }],
			renderCell: ({ row, value, colDef }) => {
				const combos = colDef.getCombos();
				const LinkToTrackingSystems = combos?.LinkToTrackingSystems;
				let DisplayValue = '';
				LinkToTrackingSystems?.forEach((item) => {
					if (item.LookupId === value) DisplayValue = item.DisplayValue;
				});
				return DisplayValue;
			},
			required: [{ field: 'EquipmentType', op: 'nin', value: ['CT', 'ETS', 'T'] }],
		},
		{
			field: 'LinkToRFIDSystems',
			header: 'LinkToRFIDSystems',
			width: 200,
			pdfExportWidth: 60,
			lookup: 'LinkToRFIDSystems',
			hidden: true,
			inputWhen: [{ field: 'EquipmentType', op: 'in', value: ['CT', 'ETS', 'T'] }],
			renderCell: ({ row, value, colDef }) => {
				const combos = colDef.getCombos();
				const LinkToRFIDSystems = combos?.LinkToRFIDSystems;
				let DisplayValue = '';
				if (LinkToRFIDSystems) {
					LinkToRFIDSystems.find((item) =>
					item.LookupId === value ? DisplayValue = item.DisplayValue : DisplayValue = ''
				);
				}
				return DisplayValue;
			}
		},
		{
			field: 'SerialNumber',
			header: 'SerialNumberSecond',
			width: 150,
			readOnly: [{ field: 'EquipmentType', op: 'in', value: ['CT', 'ETS', 'T'] }],
			required: [{ field: 'EquipmentType', op: 'nin', value: ['CT', 'ETS', 'T', 'RM', 'R'] }],
			onChange: onChangeSerialNumber
		},
		{ Header: 'IP Address', field: 'IpAddress', header: 'IPAddress', width: 150 },
		{ field: 'MachineName', header: 'DeviceName', width: 150, pdfExportWidth: 60 },
		{ field: 'MacAddress', header: 'LAN1MACAddress', width: 150, pdfExportWidth: 60, hidden: true },
		{
			field: "LAN2MACAddress", header: 'LAN2MACAddress', width: 150, pdfExportWidth: 60
		},
		{
			field: 'DeviceFamily',
			header: 'DeviceFamilyLabel',
			width: 250,
			pdfExportWidth: 60,
			customizeInput: ({ Input, inputProps }) => {
				inputProps.fieldLabel = strings.DeviceFamilyLabel;
				return <Input {...inputProps} />;
			}
		},
		{
			field: 'DeviceModel',
			header: 'DeviceModelLabel',
			width: 250,
			pdfExportWidth: 60,
			customizeInput: ({ Input, inputProps }) => {
				inputProps.fieldLabel = strings.DeviceModelLabel;
				return <Input {...inputProps} />;
			}
		},
		{
			field: 'Subscription',
			header: 'Subscribe',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'SubTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			onCreateOption: onCreateOption(consts.LookupType.SubTopics),
			onChange: onChangeSubscription,
			autocompleteValueFormatter,
			customizeInput,
			autocompleteValueParser: (value, options) => {
				let valueToShow = []
				const valuesToRemove = ['+/data', '+/cmd', '+/tdata'];
				if (value.length) {
					valueToShow = value.filter(item => !valuesToRemove.includes(item));
				}
				return valueToShow
			}
		},
		{
			field: 'SubDataPermission',
			header: 'Datatopics',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'DataTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			hidden: true,
			excludeOnGrid: true,
			customizeInput,
			onCreateOption: onCreateOption(consts.LookupType.DataTopics),
			readOnly: ({ formik }) => formik.values.Subscription?.includes?.(consts.TopicType.DataWildcard),
			onChange: ({ formik, value }) => shouldPromptAndUnauthorize({ formik, value, key: 'Subscription', topic: '+/data' })
		},
		{
			field: 'SubTDataPermission',
			header: 'Telemetrytopics',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'TDataTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			hidden: true,
			excludeOnGrid: true,
			customizeInput,
			onCreateOption: onCreateOption(consts.LookupType.TDataTopics),
			autocompleteValueFormatter,
			readOnly: ({ formik }) => formik.values.Subscription?.includes?.(consts.TopicType.TelemetryDataWildcard),
			onChange: ({ formik, value }) => shouldPromptAndUnauthorize({ formik, value, key: 'Subscription', topic: '+/tdata' })
		},
		{
			field: 'SubCmdPermission',
			header: 'Commandtopics',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'CMDDataTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			hidden: true,
			excludeOnGrid: true,
			customizeInput,
			onCreateOption: onCreateOption(consts.LookupType.CMDDataTopics),
			readOnly: ({ formik }) => formik.values.Subscription?.includes?.(consts.TopicType.CommandDataWildcard),
			autocompleteValueFormatter,
			onChange: ({ formik, value }) => shouldPromptAndUnauthorize({ formik, value, key: 'Subscription', topic: '+/cmd' })
		},
		//Publish Coloumn
		{
			field: 'Publish',
			header: 'Publish',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'PubTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			onCreateOption: onCreateOption(consts.LookupType.PubTopics),
			onChange: onChangePublish,
			autocompleteValueFormatter,
			customizeInput,
			autocompleteValueParser: (value, options) => {
				let valueToShow = []
				const valuesToRemove = ['+/data', '+/cmd', '+/tdata'];
				if (value.length) {
					valueToShow = value.filter(item => !valuesToRemove.includes(item));
				}
				return valueToShow
			}
		},
		{
			field: 'TDataPermission',
			header: 'Telemetrytopics',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'TDataTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			hidden: true,
			excludeOnGrid: true,
			customizeInput,
			onCreateOption: onCreateOption(consts.LookupType.TDataTopics),
			autocompleteValueFormatter,
			readOnly: ({ formik }) => formik.values.Publish?.includes?.(consts.TopicType.TelemetryDataWildcard),
			onChange: ({ formik, value }) => shouldPromptAndUnauthorize({ formik, value, key: 'Publish', topic: '+/tdata' })
		},
		{
			field: 'PublishDeviceType',
			header: 'CommandDeviceType',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'DeviceType',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			hidden: true,
			excludeOnGrid: true,
			customizeInput,
			autocompleteValueFormatter,
			required: [
				{
					field: 'Publish',
					op: ({ values }) => values.Publish?.includes?.(consts.TopicType.CommandData)
				}
			],
			readOnly: ({ formik }) => formik.values.Publish?.includes?.(consts.TopicType.CommandDataWildcard),
			onChange: ({ formik, value }) => shouldPromptAndUnauthorize({ formik, value, isNotCall: true })
		},
		{
			field: 'DataPermission',
			header: 'Datatopics',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'DataTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			hidden: true,
			excludeOnGrid: true,
			customizeInput,
			onCreateOption: onCreateOption(consts.LookupType.DataTopics),
			autocompleteValueFormatter,
			readOnly: ({ formik }) => formik.values.Publish?.includes?.(consts.TopicType.DataWildcard),
			onChange: ({ formik, value }) => shouldPromptAndUnauthorize({ formik, value, key: 'Publish', topic: '+/data' })
		},
		{
			field: 'CmdPermission',
			header: 'Commandtopics',
			width: 500,
			pdfExportWidth: 50,
			lookup: 'CMDDataTopics',
			preserveTypeOnSubmit: true,
			multiple: true,
			freeSolo: true,
			hidden: true,
			excludeOnGrid: true,
			customizeInput,
			onCreateOption: onCreateOption(consts.LookupType.CMDDataTopics),
			autocompleteValueFormatter,
			readOnly: ({ formik }) => formik.values.Publish?.includes?.(consts.TopicType.CommandDataWildcard),
			onChange: ({ formik, value }) => shouldPromptAndUnauthorize({ formik, value, key: 'Publish', topic: '+/cmd' })
		},
		{ field: 'LastConnection', header: 'LastConnection', type: 'dateTime', width: 200, pdfExportWidth: 50, isLocal: true },
		{
			field: 'IsActive',
			header: 'Active',
			type: 'bool',
			width: 120,
			pdfExportWidth: 50,
			filterable: false,
			renderCell: ({ value }) => {
				return <Bull value={value} />;
			}
		},
		{
			field: 'IsAuthorize',
			header: 'Authorized',
			type: 'bool',
			width: 75,
			pdfExportWidth: 50,
			hide: true,
			hidden: true,
			excludeOnGrid: true,
			disabled: ({ formik, activeRecord }) => disableAuthorize({ formik, activeRecord }),
		},
		{
			field: 'AllowUnauthorizedTopics',
			header: 'AllowUnauthorizedTopics',
			type: 'bool',
			width: 75,
			pdfExportWidth: 50,
			hide: true,
			hidden: true,
			excludeOnGrid: true
		},

		...(!isLimitedUser()
			? [
				{
					field: 'Command',
					type: 'action',
					width: 200,
					filterable: false,
					renderCell: CommandButton
				},
				{
					field: 'Delete',
					label: 'Command',
					width: 150,
					type: 'actions',
					isNotformfield: true,
					action: 'delete',
					filterable: false,
					renderCell: (params) => (
						<Button
							onClick={() => params.colDef.deleteRow(params)}
							color="error"
							variant="contained"
							title={strings.Delete}
							size="small"
							disabled={roleCheck()}
						>
							{strings.Delete}
						</Button>
					)
				}
			]
			: [])
	],
	extraExportConfig: {
		PDF: {
			pageSize: 'A3'
		}
	}
});

export default model.createFormBase();
